package com.nonopn.skywatcher.app.utils

import kotlin.math.pow
import kotlin.math.roundToInt

fun Double.round(decimals: Long = 2): Double {
    val factor = 10.0.pow(decimals.toDouble())
    return (this * factor).roundToInt() / factor
}

fun Float.round(decimals: Long = 2): Double {
    val factor = 10.0.pow(decimals.toDouble())
    return (this * factor).roundToInt() / factor
}
